import { c as _c } from "react/compiler-runtime";
import type { InterfaceToken } from '@morpho-org/dapp-core';
import { Avatar } from '@morpho-org/ui-v6/client';
import { memo } from 'react';
import ValueTransition from '@/components/common/ValueTransition';
interface VaultV2PositionRowProps {
  vaultAsset: InterfaceToken | null | undefined;
  position: {
    initial: {
      formatted: string;
      detailed?: string;
    };
    final: {
      formatted?: string;
      detailed?: string;
    };
    showFinalValue: boolean;
  };
  isLoading: boolean;
}
const VaultV2PositionRow = t0 => {
  const $ = _c(26);
  const {
    vaultAsset,
    position,
    isLoading
  } = t0;
  const t1 = vaultAsset?.logoURI;
  let t2;
  if ($[0] !== t1) {
    t2 = <Avatar size="small" src={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `Deposit (${vaultAsset?.symbol})`;
  let t4;
  if ($[2] !== t3) {
    t4 = <span className="text-3xs text-secondary-foreground">{t3}</span>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = <div className="flex flex-row items-center gap-[2px]">{t2}{t4}</div>;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = position.showFinalValue ? "text-muted-foreground" : "text-foreground";
  let t7;
  if ($[7] !== position.initial.detailed || $[8] !== position.initial.formatted || $[9] !== t6) {
    t7 = {
      value: position.initial.formatted,
      colorClass: t6,
      tooltip: position.initial.detailed
    };
    $[7] = position.initial.detailed;
    $[8] = position.initial.formatted;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== position.final.detailed || $[12] !== position.final.formatted) {
    t8 = {
      value: position.final.formatted,
      colorClass: "text-foreground",
      tooltip: position.final.detailed
    };
    $[11] = position.final.detailed;
    $[12] = position.final.formatted;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== isLoading) {
    t9 = {
      isLoading
    };
    $[14] = isLoading;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== position.showFinalValue) {
    t10 = {
      showFinalValue: position.showFinalValue
    };
    $[16] = position.showFinalValue;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t11 = <ValueTransition initial={t7} final={t8} loading={t9} config={t10} />;
    $[18] = t10;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t5) {
    t12 = <div className="flex min-h-[20px] flex-row items-center justify-between">{t5}{t11}</div>;
    $[23] = t11;
    $[24] = t5;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};
export default memo(VaultV2PositionRow);